import { useState } from "react";
import { CalendarSelection } from "./CalendarSelection";
import { CalendarSelectionTop } from "./CalendarSelectionTop";
import { AvailabilitiesIsAny, AvailabitiesBinary, convertToBinary } from "../../Utils/TimeSlotUtils";
import { CalendarBase } from "./CalendarBase";

export function CalendarSelector({ tutorAvailabilities, availabilities, availabilitiesIsAny, setCalendarValues, classNameCss }: { tutorAvailabilities: AvailabitiesBinary, availabilities: AvailabitiesBinary, availabilitiesIsAny: AvailabilitiesIsAny, setCalendarValues: (availabilities: AvailabitiesBinary, availabilitiesIsAny: AvailabilitiesIsAny) => void, classNameCss: string}) {
    const [gridColsClass, setGridColsClass] = useState("");
    const timesHalfAnHour = ["12AM", "12:30AM", "1AM", "1:30AM", "2AM", "2:30AM", "3AM", "3:30AM", "4AM", "4:30AM", "5AM", "5:30AM", "6AM", "6:30AM", "7AM", "7:30AM", "8AM", "8:30AM", "9AM", "9:30AM", "10AM", "10:30AM", "11AM", "11:30AM", "12PM", "12:30PM", "1PM", "1:30PM", "2PM", "2:30PM", "3PM", "3:30PM", "4PM", "4:30PM", "5PM", "5:30PM", "6PM", "6:30PM", "7PM", "7:30PM", "8PM", "8:30PM", "9PM", "9:30PM", "10PM", "10:30PM", "11PM", "11:30PM",];
    const daysOfTheWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const availableDays = [] as string[];

    for (const [key, value] of Object.entries(tutorAvailabilities)) {
        if (value.includes("1")) {
            availableDays.push(key);
        }
    }

    if (gridColsClass === "") {
        setGridColsClass("sample");
    }
    function setCharAt(str: string, index: number, chr: string) {
        if (index > str.length - 1) return str;
        return str.substring(0, index) + chr + str.substring(index + 1);
    }

    function setInitialBinary() {
        return convertToBinary(0);
    }
    const onTimeSelectClick = (day: string, index: number, isSelected: boolean) => {
        var isSelectedInt = (isSelected ? "1" : "0");
        var timeslot = "";
        var dayIsAny = false;
        if (index === -1) {
            if (isSelected) {
                if (tutorAvailabilities && tutorAvailabilities[day as keyof AvailabitiesBinary]) {
                    timeslot = tutorAvailabilities[day as keyof AvailabitiesBinary];
                }
                dayIsAny = true;
            } else {
                timeslot = setInitialBinary();
            }

        } else {
            if (availabilities[day as keyof AvailabitiesBinary]) {
                timeslot = setCharAt(availabilities[day as keyof AvailabitiesBinary], index, isSelectedInt);
            }
            if (timeslot === tutorAvailabilities[day as keyof AvailabitiesBinary]) {
                dayIsAny = true;
            }
        }

        const newRequestingAvailabilities = { ...availabilities, [day as keyof AvailabitiesBinary]: timeslot };
        const newRequestingAvailabilitiesIsAny = { ...availabilitiesIsAny, [day as keyof AvailabitiesBinary]: dayIsAny };

        setCalendarValues(newRequestingAvailabilities, newRequestingAvailabilitiesIsAny);
    };
    const getDayUnavailableOverlay = (day: string) => {
        return (
            <div className="grid grid-rows-height-30mins">
                {
                    Array.from({ length: 48 }, (_, sindex) => (
                            (availableDays.indexOf(day) === -1 || (tutorAvailabilities && tutorAvailabilities[day as keyof AvailabitiesBinary].charAt(sindex) === "0")) ?
                                <div className="calendar-gap-lines bg-gray-100" key={sindex}></div>
                                :
                                <div className="calendar-gap-lines" key={sindex}></div>
                        ))
                }
            </div>
        )
    }

    function getButtonOverlay(day: string) {
        return (
            <div className="grid grid-rows-height-30mins">
                {
                    Array.from({ length: 48 }, (_, sindex) => (
                        (availableDays.indexOf(day) > -1 && (tutorAvailabilities && tutorAvailabilities[day as keyof AvailabitiesBinary].charAt(sindex) === "1")) ?
                            <CalendarSelection day={day} label={timesHalfAnHour[sindex]} rowStart={sindex} onUserChange={onTimeSelectClick} dayAvailabilities={availabilities} key={sindex}></CalendarSelection>
                            : <div className="calendar-gap" key={sindex}></div>
                    ))
                }
            </div>
        )
    }
    function getLeadingSectionOverlay(day: string) {
        return (
            (availableDays.indexOf(day) === -1) ?
                (<div className="calendar-leading-fill">

                </div>)
                :
                <CalendarSelectionTop day={day} label={"SELECT ALL"} dayAvailabilities={availabilities} tutorAvailabilities={tutorAvailabilities ?? {} as AvailabitiesBinary} onUserChange={onTimeSelectClick} ></CalendarSelectionTop>
        )
    }
    const secondaryLayer = () => {
        return (
            <>
                {daysOfTheWeek.map((day, index) => (
                    <div key={index}>
                        <div className="calendar-leading" >

                        </div>
                        {getDayUnavailableOverlay(day)}
                        </div>
                    ))}
            </>
        )

    }
    const mainLayer = () => {
        return (
            <>
                {daysOfTheWeek.map((day, index) => (
                    <div key={index}>
                        {getLeadingSectionOverlay(day)}
                        {getButtonOverlay(day)}
                    </div>
                ))}
            </>
        )
      
    }
    const gutterLayer = () => {
        return (
            <>
            </>
        )
      
    }
    return (
        <CalendarBase classNameCss={classNameCss} mainLayer={mainLayer} secondaryLayer={secondaryLayer} gutterLayer={gutterLayer} week={0}></CalendarBase>
    );
}